import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import {
  closeEmbeddedMediaViewer,
  isEmbeddedMediaViewerPathname
} from '@helpers/uxpEmbeddedMediaViewer';

const UXP_EMBEDDED_MEDIA_VIEWER_SESSION_KEY = 'uxpEmbeddedMediaViewer';

export function UxpEmbeddedNavigationGuard() {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const { uxpHost } = window as unknown as {
      uxpHost?: { postMessage: (msg: object) => void };
    };
    if (!uxpHost) return;

    const isEmbeddedMediaViewer =
      isEmbeddedMediaViewerPathname(pathname) &&
      searchParams.get('embedded') === '1';

    if (isEmbeddedMediaViewer) {
      sessionStorage.setItem(UXP_EMBEDDED_MEDIA_VIEWER_SESSION_KEY, '1');
      return;
    }

    if (sessionStorage.getItem(UXP_EMBEDDED_MEDIA_VIEWER_SESSION_KEY) !== '1') {
      return;
    }

    if (isEmbeddedMediaViewerPathname(pathname)) return;

    sessionStorage.removeItem(UXP_EMBEDDED_MEDIA_VIEWER_SESSION_KEY);
    closeEmbeddedMediaViewer();
  }, [pathname, searchParams]);

  return null;
}
